import { VendorBuyingAgreementBuyOpportunityDetail } from '../../../components/Vendor';

export function BuyingAgreementBuyOpportunity() {
  return <VendorBuyingAgreementBuyOpportunityDetail />;
}
